import { getUserData } from "@/auth/getUserData";
import { computed } from "@vue/composition-api";
import store from "@/store";
import { useUsersStore } from "@/store/useUsersStore";

export default function useUserStatus() {
    const { updateUser } = useUsersStore();

    const onlineStatus = computed({
        get: () => {
            return store.state.userConfig.status;
        },
        set: (status) => {
            store.commit("userConfig/UPDATE_STATUS", status); // put it into the store state for F5.
            updateUser(getUserData().id, {
                status,
            });
        },
    });

    return {
        onlineStatus,
    };
}
